import Statistics from "@/views/statistics/Statistics"
export const statistics = {
    path: '/statistics',
    name: 'Statistics',
    component: Statistics
  }


// WEBPACK FOOTER //
// ./src/router/index/statistics/index.js